export default {
  BIGGESTDESKTOP: 1900,
  BIGDESKTOP: 1600,
  BIGGERDESKTOP: 1350,
  DESKTOP: 1200,
  TABLET: 768,
  PHONE: 376,
  SMALLPHONE: 374,
}
